import './navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import UserContext from '../../Context/User/userContext';
import axios from 'axios';
import moment from 'moment/moment';
import { Badge } from 'antd';

function NavbarComp() {
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate()
    const [siteUserExist, setSiteUserExist] = useState(false);
    const [notification, setNotification] = useState([]);

    const logoutUser = () => {
        localStorage.clear()
        setUser(null)
        navigate('/')
    }

    const [adminExist, setAdminExist] = useState(false)

    // Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";
    const userObj = user && (typeof user === 'string' ? JSON.parse(user) : user);
    const _id = userObj && userObj._id;

    const checkForAdmin = async () => {
        try {
            const response = await axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/validateAdmin/${_id}`, {
                headers: {
                    'Authorization': `Bearer ${tokenValue}`
                    // You can add other headers if needed like authorization token, etc.
                }
            });

            // Determine if the user is an admin based on the API response
            setAdminExist(response.data.success);
        } catch (error) {
            console.error("Error:", error.response?.data?.message || error.message);
            setAdminExist(false); // Return false in case of an error
        }
    };

    const getNotifications = () => {
        axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/user?id=${_id}`, {
            headers: {
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                // Handle success
                setNotification(res.data.user.notifications.reverse());
            })
            .catch(error => {
                console.error("Error:", error?.response?.data?.message);
            });
    }

    useEffect(() => {
        if (user) {
            checkForAdmin();
            getNotifications();
            checkSiteUser();
        }
    }, [user])

    const deleteNotification = (notificationId) => {
        // Construct the URL with query parameters
        const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/auth/notification/${_id}/${notificationId}`;

        axios.delete(url, {
            headers: {
                'Authorization': `Bearer ${tokenValue}`
                // Add other headers if needed
            }
        })
            .then(res => {
                // Handle success
                getNotifications(); // Fetch updated notifications
            })
            .catch(error => {
                console.error("Error:", error.response ? error?.response?.data?.message : error);
            });
    };

    const checkSiteUser = () => {
        if (localStorage.getItem('siteUser')) {
            setSiteUserExist(true)
        } else {
            setSiteUserExist(false)
        }
    }

    const exitUserMode = () => {
        // Remove the user from localStorage
        localStorage.removeItem('siteUser');

        // Clear the user state
        setUser(JSON.parse(localStorage.getItem('user')));

        // Log the action for debugging purposes
        console.log('exitUserMode');

        // Navigate to the home page
        navigate('/home');
    };

    return (
        <nav className="navbar navbar-expand-lg">
            {user && <div style={{ backgroundColor: '#F2F2F2', boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' }} className="container">
                <Link className="navbar-brand" to="/home" style={{ color: '#178383', fontWeight: 'bolder', fontSize: '17px', fontFamily: 'nunito' }}>Research Mate</Link>
                {siteUserExist && <Link className="navbar-brand" to="/home" style={{ color: 'red', fontWeight: 'bolder', fontSize: '17px', fontFamily: 'nunito' }}>Logged In As {userObj.firstName} {userObj.lastName}</Link>}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        {adminExist && <li className="nav-item">
                            <Link to="/sites" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px' ,fontFamily:'nunito'}} aria-current="page" href="#">Organization</Link>
                        </li>}
                        {adminExist && <li className="nav-item">
                            <Link to="/sponsorStudy" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px',fontFamily:'nunito' }} aria-current="page" href="#">Sponsers Studies</Link>
                        </li>}
                        <li className="nav-item">
                            <Link to="/home" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px',fontFamily:'nunito' }} aria-current="page" href="#">My Organization</Link>
                        </li>
                        {!adminExist && <li className="nav-item">
                            <Link to="/myStudy" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px',fontFamily:'nunito' }} aria-current="page" href="#">My Study</Link>
                        </li>}
                        <li className="nav-item">
                            <Link to="/activeStudy" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px',fontFamily:'nunito' }} href="#">Active Studies</Link>
                        </li>
                        {adminExist && <li className="nav-item">
                            <Link to="/developingStudy" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px',fontFamily:'nunito' }} href="#">Developing Studies</Link>
                        </li>}
                        {adminExist && <li className="nav-item">
                            <Link to="/closeStudy" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px',fontFamily:'nunito' }} href="#">Close Studies</Link>
                        </li>}
                        {adminExist && <li className="nav-item">
                            <Link to="/createStudy/false" className="nav-link" style={{ color: '#178383', fontWeight: 'bold', fontSize: '15px',fontFamily:'nunito' }} href="#">Create Study</Link>
                        </li>}
                        <li className="nav-item dropdown">
                            <Link className="nav-link" href="#" id="navbarDropdownNotification" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <Badge count={notification.length > 99 ? '+99' : notification.length}>
                                    <i style={{ color: '#178383', fontWeight: 'bolder', fontSize: '16px' }} className="bi bi-bell"></i>
                                </Badge>
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end scroll-custom" aria-labelledby="navbarDropdownNotification">
                                <li
                                    className="dropdown-header"
                                    style={
                                        {
                                            color: '#178383',
                                            fontSize: '18px'
                                        }
                                    }>
                                    Notifications  <Badge count={notification.length > 99 ? '+99' : notification.length}>
                                    <i style={{ color: '#178383', fontWeight: 'bolder', fontSize: '16px' ,fontSize: '18px',marginLeft:'10px'}} className="bi bi-bell"></i>
                                </Badge>
                                </li>
                                {notification ? notification.map((v, i) => {
                                    return (
                                        <li key={i}>
                                            <div className="dropdown-item">
                                                <div className="d-flex justify-content-between">
                                                    {
                                                        v.message === "Added a new study" ?
                                                            <Link to={`/activeStudyForm/${v._id}`} style={{ textDecoration: 'none', color: '#178383',fontWeight:'400', fontSize: '12px' }}>
                                                                <span className="fw-bold me-1">{v.name}</span>
                                                                {v.message}
                                                                <br />
                                                                {moment(`${v.timestamp}`).fromNow()}
                                                            </Link> : <Link style={{ textDecoration: 'none', color: '#178383',fontWeight:'400', fontSize: '15px' }}>
                                                                <span className="fw-bold me-1">{v.name}</span>
                                                                {v.message}
                                                                <br />
                                                                {moment(`${v.timestamp}`).fromNow()}
                                                            </Link>
                                                    }
                                                    <div style={{ cursor: 'pointer',marginLeft:'40px' }} onClick={e => deleteNotification(`${v._id}`)} >
                                                        <small  className='mx-4'  style={{color:'red'}}>Mark As Read</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                }) :
                                    <li>
                                        <Link className="dropdown-item" href="#">
                                            <div className="d-flex justify-content-between">
                                                <div style={{ color: '#178383', fontSize: '12px' }}>
                                                    No new notifications
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                }
                            </ul>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle" href="#" id="navbarDropdownProfile" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                {
                                    userObj.profilePic?.url ?
                                        <img
                                            src={userObj.profilePic?.url}
                                            style={{
                                                width: '30px',
                                                height: '30px',
                                                borderRadius: '50%'
                                            }}
                                            alt="Profile" /> :

                                        <i
                                            style={{
                                                color: '#178383',
                                                fontWeight: 'bolder',
                                                fontSize: '16px'
                                            }}
                                            className="bi bi-person-circle"
                                        >
                                        </i>

                                }
                            </Link>
                            <ul className="dropdown-menu" aria-labelledby="navbarDropdownProfile">
                                {
                                    adminExist &&
                                    <>
                                        <li><Link className="dropdown-item" to="/dashboard" href="#" style={{ color: '#178383', fontWeight: 'bold', fontSize: '12px' }}>Dashboard</Link></li>
                                        <li><Link className="dropdown-item" to="/siteRequest" style={{ color: '#178383', fontWeight: 'bold', fontSize: '12px' }}>Site Request</Link></li>
                                    </>
                                }
                                <li>
                                    {
                                        siteUserExist ?
                                            <Link onClick={exitUserMode} className="nav-link" style={{ color: 'red', fontWeight: 'bold', fontSize: '15px' }} aria-current="page" href="#">Exit User Mode</Link>
                                            :
                                            <Link className="dropdown-item" onClick={logoutUser} style={{ color: '#178383', fontWeight: 'bold', fontSize: '12px' }}>Sign Out
                                                <i style={{ color: '#178383', fontWeight: 'bolder', fontSize: '15px' }} className="mx-3 bi bi-box-arrow-right"></i>
                                            </Link>
                                    }
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>}
        </nav>
    );
}

export default NavbarComp;
